export const queryKeys = {
  balance: (playerId: number | null | undefined) =>
    ["balance", playerId] as const,
  balanceRoot: ["balance"] as const,
};
